export default "/images/SL_pneus.png?fd13d9461d3df18a3ddba57294ab7206";